module.exports = __webpack_public_path__ + "media/music_19.9c412853.mp3";